export const checkRoles = (user) => {
  const roles = user?.roles || [];

  return {
    isSystemAdmin: roles.some((role) => role.name === "System Admin"),
  };
};

export const getPermissionFlags = (user) => {
  const { isSystemAdmin } = checkRoles(user);

  return {
    isAnyAdmin: isSystemAdmin,
  };
};
